import { useEffect, useRef, useState } from 'react';
import { useHover } from 'react-native-web-hooks';

const HOVER_DELAY_MS = 150;

export const useDelayedHover = <T>(targetRef: React.RefObject<T>) => {
  const isCurrentlyHovered = useHover(targetRef);
  const [isHoveredDelayed, setIsHoveredDelayed] = useState(false);
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => {
    if (isCurrentlyHovered) {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
      timerRef.current = setTimeout(() => {
        setIsHoveredDelayed(true);
        timerRef.current = null;
      }, HOVER_DELAY_MS);
    } else {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
        timerRef.current = null;
      }
      setIsHoveredDelayed(false);
    }

    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
        timerRef.current = null;
      }
    };
  }, [isCurrentlyHovered]);

  return isHoveredDelayed;
};
